const ActivityLog = {
  path: "",
  name: "",
  redirect: "/activitylog",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/activitylog",
      redirect: "/activitylog",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Activity Log",
      meta: {
        requiresAuth: true,
        activeUrl: "/activitylog",
        parent: "/activitylog",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/activityLog"),
          meta: {
            requiresAuth: true,
            activeUrl: "/activitylog",
            parent: "/activitylog",

            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Activity Log Detail",
          component: () => import("@/views/pages/activityLog/Detail"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/activitylog",
            parent: "/activitylog",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default ActivityLog;
